import { createContext, useContext } from 'react';

type CustomerProduct = {
  id: string;
  providerId: string;
  providerType: 'B2B' | 'DTC' | 'PARTNER' | 'UNKNOWN';
};

export type CustomerType = {
  id: string;
  products: Array<CustomerProduct>;
  subscriptionTracking: unknown;
};

export type CustomerTypeContext = {
  loading: boolean;
  hasActiveSubscription: boolean;
  subscriptions: CustomerType['products'];
  subscriptionTracking: CustomerType['subscriptionTracking'];
  updateCardRelevant: boolean;
};

export const customerTypeContext = createContext<CustomerTypeContext | null>(null);

export function CustomerTypeProviderContext({
  children,
  customerType,
}: {
  children: React.ReactNode;
  customerType: CustomerTypeContext;
}) {
  return (
    <customerTypeContext.Provider value={customerType}>{children}</customerTypeContext.Provider>
  );
}

export function useCustomerType() {
  const context = useContext(customerTypeContext);
  if (!context) {
    throw new Error('useCustomerType must be used within a CustomerTypeProvider');
  }
  return context;
}
